export default class DatePicker {

  eInput: any;

  init(params: any) {
    this.eInput = document.createElement("input");
    this.eInput.setAttribute("type", "date");
    this.eInput.value = params.value;
  }

  getGui() {
    // @ts-ignore
    return this.eInput;
  }

  afterGuiAttached() {
    // @ts-ignore
    this.eInput.focus();
    // @ts-ignore
    this.eInput.select();
  }

  getValue() {
    // @ts-ignore
    return this.eInput.value;
  }

  destroy() {
    // TODO change
  }

  isPopup() {
    return false;
  }

}
